<div class="family-modal-container">
  <div class="modal-header">
    <span class="modal-title"><strong>{{ labels.createTitle }}</strong></span>
  </div>
  <div class="modal-divider"></div>
  <div class="body">
    <app-input [label]="labels.nameLabel"
               [control]="getFamilyControl('name')">
    </app-input>
    <div class="table">
      <span class="vip-title">{{ labels.tableCreateTitle }}</span>
      <div *ngIf="vipLevels.length > 0" class="table-title">
        <span>*</span>
        <span>{{labels.vipLevelName}}<span class="error">*</span></span>
        <span><span [innerHTML]="labels.inkRequired"></span><span class="error">*</span></span>
        <span>{{labels.discount}}(%)<span class="error">*</span></span>
      </div>
      <form [formGroup]="formVip">
        <div *ngFor="let vip of vipLevels" class="body-vip-modal">
          <span class="item">{{ getControlByVipType(vip.id, 'label').value }}</span>
          <app-input [control]="getControlByVipType(vip.id, 'name')"
                     [errorHint]="false"
                     [formGroup]="formVip">
          </app-input>
          <app-input [control]="getControlByVipType(vip.id, 'levelPoints')"
                     [errorHint]="false"
                     [formGroup]="formVip"
                     [type]="'number'">
          </app-input>
          <app-input [control]="getControlByVipType(vip.id, 'discount')"
                     [errorHint]="false"
                     [formGroup]="formVip"
                     [type]="'number'">
          </app-input>
          <app-icon-click small (click)="deleteLine(vip.id)">{{ 'delete' }}</app-icon-click>
        </div>
        <div *ngIf="vipLevels.length <= 0" class="empty-list">
          <span >{{labels.emptyList}}</span>
        </div>
        <div class="add-line-container">
          <app-icon-button icon="add_box"
                           type="submit" (clickAction)="addNewLine()">
            {{ labels.addVipLevel }}
          </app-icon-button>
        </div>
        <div class="generic-errors">
          <ul>
            <li class="error" *ngFor="let msg of getGenericErrorsFiltered()">{{ msg }}</li>
          </ul>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <app-primary-button stroked (clickAction)="clickCancel()">{{ labels.cancel }}</app-primary-button>
    <app-primary-button (clickAction)="clickSave()" [disabled]="formVip.invalid || formFamily.invalid || loading">{{ labels.saveChanges }}</app-primary-button>
  </div>
</div>
